<template>
  <vxe-modal v-model="visible" :destroyOnClose="true" :loading="loading" :title="$t('title.poPickup')" show-footer size="mini" type="confirm" width="70%" @confirm="handleOk">
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-input v-model="parameter.no" clearable placeholder="business.label.orderNo" @clear="search" @keydown.native.enter="search"/>
        <vxe-input v-model="parameter['supplier.name']" clearable placeholder="business.label.supplierName" @clear="search" @keydown.native.enter="search"/>
        <vxe-input v-model="parameter['item.filter']" clearable placeholder="business.label.itemName" @clear="search" @keydown.native.enter="search"/>
        <vxe-date-range-picker v-model="parameter.range" :autoClose="false" clearable placeholder="business.label.invoiceTime" showConfirmButton type="date" @clear="search" @confirm="search"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="search"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table
        ref="orderTable"
        :data="orders"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :column-config="{resizable: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        show-overflow
        size="mini"
        @cell-click="onOrderSelect">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="no" title="business.label.orderNo" width="130"/>
        <vxe-column field="supplier.name" title="business.label.customerName"/>
        <vxe-column field="invoiceTime" title="business.label.invoiceDate" width="170"/>
        <vxe-column field="operator" title="business.label.operator" width="80"/>
        <vxe-column field="buyer" title="business.label.buyer" width="80"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
        <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <vxe-card size="mini" width="100%">
      <vxe-table
        ref="detailsTable"
        :checkbox-config="{trigger: 'row'}"
        :data="details"
        :edit-config="{trigger: 'click', mode: 'cell'}"
        :row-config="{isCurrent: true, isHover: true}"
        :column-config="{resizable: true}"
        align="center"
        border
        keep-source
        max-height="600"
        show-overflow
        size="mini">
        <vxe-column fixed="left" type="checkbox" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="250"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="180"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
        <vxe-column field="lotNo" title="business.label.lotNo" width="150"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="numberOfEach" title="business.label.numberOfEach" width="100"/>
        <vxe-column field="number" title="business.label.number" width="100"/>
        <vxe-column field="plannedQuantity" title="business.label.quantity" width="100"/>
        <vxe-column field="productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="validUntil" title="business.label.validUntil" width="100"/>
      </vxe-table>
    </vxe-card>
  </vxe-modal>
</template>

<script>
import { findAll, post } from '@/api/Api'
import moment from 'moment/moment'
import { mixin, mixinDevice } from '@/utils/mixin'
import { AsnDetail, AsnOrder } from '@/api/dto/order/AsnOrder'
import api from '@/api'
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { Dictionary } from '@/api/dto/admin/Dictionary'

export default {
  name: 'PoModal',
  mixins: [mixin, mixinDevice],
  data() {
    return {
      visible: false,
      loading: false,
      confirmLoading: false,
      order: null,
      warehouse: Vue.ls.get(WAREHOUSE),
      orderNo: '',
      purchaseOrderRow: 0,
      orders: [],
      purchaseDetailListCopy: [],
      details: [],
      parameter: {
        no: '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
        refundable: false,
        completed: false,
        draw: false,
        extracted: false,
        'item.filter': '',
        'supplier.name': ''
      },
      page: 1,
      size: 5,
      contentSize: 0,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 }
    }
  },
  methods: {
    onQuantityChanged(target) {
      target.number = Math.floor(target.plannedQuantity / target.pack.factor)
      target.numberOfEach = target.plannedQuantity - target.number * target.pack.factor
    },
    reset() {
      this.page = 1
      this.size = 5
      this.parameter['no'] = ''
      this.parameter['item.filter'] = ''
      this.parameter['supplier.name'] = ''
      this.orderNo = ''
      this.purchaseOrderRow = 0
      this.orders = []
      this.purchaseDetailListCopy = []
      this.details = []
      this.order = null
      this.query()
    },
    query() {
      this.page = 1
      this.fetch()
    },
    open(order) {
      this.reset()
      if (order) {
        this.order = JSON.parse(JSON.stringify(order))
      }
      this.visible = true
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      let args = Object.assign({}, this.parameter)
      if (args.range.length !== 0) {
        args['dateFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['dateFilter'] = null
      }
      findAll('receivingPoPickupFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.orders = res.result
          this.details = []
        }
      }).finally(() => {
        this.loading = false
      })
    },
    search() {
      this.page = 1
      this.fetch()
    },
    onOrderSelect({ row }) {
      this.purchaseOrderRow = row
      this.details = row['details']
      if (this.details) {
        this.details.forEach(dtl => {
          this.onQuantityChanged(dtl)
        })
      }
      this.$nextTick(() => {
        this.$refs.detailsTable.setAllCheckboxRow(true)
      })
    },
    handleOk() {
      this.purchaseDetailListCopy = []
      this.$refs.detailsTable.getCheckboxRecords().forEach(d => {
        let detail = Object.assign({}, d)
        detail.id = null
        detail.purchaseDetail = {
          id: d.id
        }
        this.purchaseDetailListCopy.push(detail)
      })
      if (this.order !== null) {
        let that = this
        this.$confirm({
          title: '检测到主界面存在ASN单:' + this.order.no,
          content: '是否追加提取',
          onOk() {
            that.order['details'] = that.getAsnDetails(that.purchaseDetailListCopy)
            that.order.address = that.order.address.skipNulls()
            that.order.conveyance = Object.assign(new Dictionary(), that.order.conveyance)
            that.order.tempControlMode = Object.assign(new Dictionary(), that.order.tempControlMode)
            that.order.conveyance = that.order.conveyance.skipNulls()
            that.order.tempControlMode = that.order.tempControlMode.skipNulls()
            that.asnSave(that.order)
          },
          onCancel() {
            let asnOrder = that.generateAsn()
            that.asnSave(asnOrder)
          },
          okText: '追加提取',
          cancelText: '生成新单',
          centered: true
        })
      } else {
        let asnOrder = this.generateAsn()
        this.asnSave(asnOrder)
      }
    },
    generateAsn() {
      let asnOrder = this.getAsnOrder(this.purchaseOrderRow)
      asnOrder.address = asnOrder.address.skipNulls()
      asnOrder.details = this.getAsnDetails(this.purchaseDetailListCopy)
      asnOrder.tempControlMode = asnOrder.tempControlMode.skipNulls()
      asnOrder.conveyance = asnOrder.conveyance.skipNulls()
      asnOrder.warehouse = this.warehouse
      return asnOrder
    },
    asnSave(order) {
      this.confirmLoading = true
      post(api.receivingAsnSave, { type: 'normalAsn' }, order).then(res => {
        if (res.success) {
          this.$success({ title: '提取成功', centered: true })
          this.$emit('success', res.result)
          this.visible = false
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    getAsnOrder(poHeader) {
      let asnOrder = new AsnOrder()
      if (poHeader.orderType) {
        Object.assign(asnOrder.orderType, poHeader.orderType)
      }
      if (poHeader.storer) {
        Object.assign(asnOrder.storer, poHeader.storer)
      }
      if (poHeader.supplier) {
        Object.assign(asnOrder.customer, poHeader.supplier)
      }
      return asnOrder
    },
    getAsnDetails(poDetails) {
      const details = []
      poDetails.forEach(pd => {
        const detail = new AsnDetail(pd)
        detail.quantity = pd.plannedQuantity
        detail.purchaseDetail = pd.purchaseDetail
        detail.version = 0
        details.push(detail)
      })
      return details
    }
  }
}
</script>